import Vue from 'vue'
import store from './store'
import Game from './views/game'
import Router from 'vue-router'
import Order from './views/order'
import Store from './views/store'
import Result from './views/result'
import Wallet from './views/wallet'
import Products from './views/products'
import Coupon from './views/coupon'
// import ChannelPay from './views/channelPay'
import PasswordSetting from './views/passwordSetting'
import { datain } from './utils'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/wallet'
    },
    {
      path: '/store',
      name: 'store',
      component: Store
    },
    {
      path: '/result',
      name: 'result',
      component: Result
    },
    {
      path: '/products',
      name: 'products',
      component: Products
    },
    {
      path: '/game',
      name: 'game',
      component: Game
    },
    // {
    //   path: '/channelPay',
    //   name: 'channelPay',
    //   component: ChannelPay
    // },
    {
      path: '/passwordSetting',
      name: 'passwordSetting',
      component: PasswordSetting
    },
    {
      path: '/order',
      name: 'order',
      component: Order
    },
    {
      path: '/wallet',
      name: 'wallet',
      component: Wallet
    },
    {
      path: '/coupon',
      name: 'coupon',
      component: Coupon
    }
  ]
})

let routerMap = {
  wallet: '加載我的錢包',
  order: '加載訂單頁面',
  passwordSetting: '加載設置二級密碼',
  game: '加載遊戲選擇頁面',
  products: '加載商品列表頁面',
  result: '加載結果頁面',
  store: '加載儲值頁面',
  coupon: '加載抵用券頁面'
}

window.isUsedReferrer = false

router.beforeEach((to, from, next) => {
  if (to.name !== from.name) {
    store.commit('setLoadingState', true)
  }
  next()
})

router.afterEach((to, from) => {
  let event = routerMap[to.name] || '加載首頁'
  let origin =
        window.location.protocol +
        '//' +
        window.location.hostname +
        (window.location.port ? ':' + window.location.port : '')
  let fromPage = window.isUsedReferrer
    ? origin + '#' + from.fullPath
    : document.referrer
  store.commit('setPageInfo', {
    fromPage,
    pageName: event.replace('加載', '')
  })
  try {
    datain({
      event: 'load',
      ext3: event
    })
    window.sdkBehave.push({
      event,
      type: 'gm_wallet', 
      gaEventName: routerMap[to.name] ? to.name + 'Load' : 'homeLoad'
    })
  } catch (e) {}
})

export default router
